import { Container } from '@/components/Container';
import { AppLink } from '@/components/AppLink';
import { Callout } from '@/components/Callout';
import { Card, CARD_TITLE } from '@/components/Card';
import { DraftMarker } from '@/components/DraftMarker';
import { FileLink } from '@/components/FileLink';
import { PageHeader } from '@/components/PageHeader';
import { AFFILIATION_RULES, OVERSEAS_RULES } from '@/data/content';
import { FILES } from '@/data/files';
import { photos } from '@/data/images';

function RuleList({ items }: { items: readonly string[] }) {
  return (
    <ul className="m-0 list-none border-t border-rule p-0">
      {items.map((r) => (
        <li key={r} className="border-b border-rule py-3.5 text-[1.125rem] font-semibold text-ink">{r}</li>
      ))}
    </ul>
  );
}

export function Affiliation() {
  return (
    <>
      <PageHeader
        title="Affiliation"
        intro="Institutes in India and overseas can affiliate with ITES to teach its courses and sponsor students for its examinations."
        image={photos.affiliation}
        objectPosition="center 58%"
      />
      <Container className="grid grid-cols-[repeat(auto-fit,minmax(min(100%,380px),1fr))] items-start gap-8 pt-[clamp(32px,5vw,56px)] pb-[clamp(56px,7vw,96px)]">
        <Card as="section" aria-labelledby="h-rules">
          <h2 id="h-rules" className={CARD_TITLE}>Affiliation in India</h2>
          <p className="m-0 mb-[18px] text-[1.125rem] leading-[1.6] text-ink-2">The affiliation rules cover:</p>
          <RuleList items={AFFILIATION_RULES} />
          <DraftMarker className="mt-4">
            CMS · full rules text added by ITES · fees and bank details are not shown publicly
          </DraftMarker>
          <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-3">
            <FileLink as="button" href={FILES.affiliationRules} label="Affiliation rules (PDF)" />
            <AppLink href="/notices" className="tap font-semibold underline">Current fee chart →</AppLink>
          </div>
        </Card>

        <div className="flex flex-col gap-8">
          <Card as="section" aria-labelledby="h-overseas">
            <h2 id="h-overseas" className={CARD_TITLE}>Overseas affiliation</h2>
            <p className="m-0 mb-[18px] text-[1.125rem] leading-[1.6] text-ink-2">
              Institutes outside India can affiliate with ITES and conduct ITES examinations. The overseas rules cover:
            </p>
            <RuleList items={OVERSEAS_RULES} />
            <FileLink href={FILES.affiliationForm} label="Affiliation form (PDF)" className="mt-6 inline-block" />
          </Card>

          {/* The one "get in touch" box on this page. */}
          <Callout tone="navy" aria-labelledby="h-questions">
            <h3 id="h-questions" className="m-0 font-serif text-h4 font-semibold">Questions about affiliation?</h3>
            <p className="mt-2.5 mb-3.5 text-[1.0625rem] leading-[1.55] text-on-dark">
              Call 022 2166 1295 or email itesmumbai@gmail.com.
            </p>
            <AppLink href="/contact" className="tap font-semibold text-sky-300 underline">
              Contact the ITES office →
            </AppLink>
          </Callout>
        </div>
      </Container>
    </>
  );
}
